// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/** RentAll - Begin **/

.PriceDetailsModal-logInModalContainer-ww3ni {
    max-width: 780px;
    width: 100%;
}

.PriceDetailsModal-logInModalBody-IE3Iz {
    padding: 0px;
}

.PriceDetailsModal-panelHeader-cgHWO {
    font-size: 16px;
    padding-top: 12px;
    padding-bottom: 12px;
    border-bottom: 1px solid var(--primary-border);
    background: transparent;
    text-align: center;
}

@media (max-width:991px) and (min-width:768px) {
    .PriceDetailsModal-logInModalContainer-ww3ni {
        width: auto;
        display: block;
        margin: 30px 15px;
        max-width: 100%;
    }
}

@media screen and (max-width: 767px) {
    .PriceDetailsModal-logInModalContainer-ww3ni {
        display: block;
        width: auto;
        max-width: 100%;
    }
}`, "",{"version":3,"sources":["webpack://./src/components/SearchListing/ListingItem/PriceDetailsModal.css"],"names":[],"mappings":"AAAA,sBAAsB;;AAEtB;IACI,gBAAgB;IAChB,WAAW;AACf;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,oBAAoB;IACpB,8CAA8C;IAC9C,uBAAuB;IACvB,kBAAkB;AACtB;;AAEA;IACI;QACI,WAAW;QACX,cAAc;QACd,iBAAiB;QACjB,eAAe;IACnB;AACJ;;AAEA;IACI;QACI,cAAc;QACd,WAAW;QACX,eAAe;IACnB;AACJ","sourcesContent":["/** RentAll - Begin **/\n\n.logInModalContainer {\n    max-width: 780px;\n    width: 100%;\n}\n\n.logInModalBody {\n    padding: 0px;\n}\n\n.panelHeader {\n    font-size: 16px;\n    padding-top: 12px;\n    padding-bottom: 12px;\n    border-bottom: 1px solid var(--primary-border);\n    background: transparent;\n    text-align: center;\n}\n\n@media (max-width:991px) and (min-width:768px) {\n    .logInModalContainer {\n        width: auto;\n        display: block;\n        margin: 30px 15px;\n        max-width: 100%;\n    }\n}\n\n@media screen and (max-width: 767px) {\n    .logInModalContainer {\n        display: block;\n        width: auto;\n        max-width: 100%;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"logInModalContainer": `PriceDetailsModal-logInModalContainer-ww3ni`,
	"logInModalBody": `PriceDetailsModal-logInModalBody-IE3Iz`,
	"panelHeader": `PriceDetailsModal-panelHeader-cgHWO`
};
module.exports = ___CSS_LOADER_EXPORT___;
